import axios from 'axios';
import Cookies from 'js-cookie';
export const BACKEND_URL = "https://test2.dingai.io/api";

const api = axios.create({
    baseURL: BACKEND_URL,
    timeout: 5000,
});

// ---------------------Admin login api -------------------------------
export const adminLogin = async (data) => {
    try {
        const response = await api.post('/admin/login', data);
        const token = response?.data?.token;
        const id = response?.data?.data?._id;
        const type = response?.data?.type;

        Cookies.set('token', token);

        return {
            status: true,
            message: "Admin Logged in successfully",
            token: token,
            id: id,
            type
        };
    } catch (error) {
        console.error('API Error:', error);

        if (error.code === 'ERR_NETWORK') {
            return {
                status: false,
                message: "Unable to connect to server. Please check if the server is running."
            };
        }

        if (error?.response?.status === 400) {
            return { status: false, message: error.response.data.message };
        }

        return {
            status: false,
            message: error?.response?.data?.message || "An unexpected error occurred"
        };
    }
};

// Fetch all shops with authorization and pagination
export const getAllShops = async (page = 1, value) => {
    try {
        const token = Cookies.get('token');
        const response = await api.get(`/auth/allShops?page=${page}&limit=10&search=${value}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        return {
            status: 'error',
            currentPage: 1,
            totalPages: 1,
            totalUsers: 0,
            data: []
        };
    }
};

// Get access data for a user
export const getAccessData = async (userId) => {
    try {
        const token = Cookies.get('token');
        const response = await api.get(`/auth/getAccessData?userId=${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        return { status: 'error', data: null };
    }
};

// Configure axios defaults for authorized requests
const getAuthHeader = () => {
    const token = Cookies.get('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export default BACKEND_URL; 